/**
 * Quest-gated portals (plan 27 D50, lane BL).
 *
 * A teleporter platform can be authored `requiredQuest: "<quest id>"` (flat on
 * the level-JSON platform, or inside `teleporterConfig`). It stays shut until
 * the traveller has completed that quest: Tidewend's ferry to Wickhaven waits
 * for The Hollow Keeper. The level gate (portalGate.ts) still applies on top.
 *
 * The server is the authority (world-transfer/PortalTransferPolicy refuses the
 * trip with `portal_quest_required`); the client shows the refusal's copy.
 * Peaceful tourists, god mode and GMs pass, as they pass level gates. The
 * portal graph (portalGraph.ts) ignores the gate, like level gates: the story
 * map set is everything the walk can ever reach.
 */

export interface PortalQuestGateInput {
  requiredQuest?: string;
  teleporterConfig?: { requiredQuest?: string } | null;
}

/** The quest a portal waits for, or null when it is not quest-gated. */
export function portalRequiredQuest(portal: PortalQuestGateInput): string | null {
  const id = portal.teleporterConfig?.requiredQuest ?? portal.requiredQuest;
  return typeof id === 'string' && id.length > 0 ? id : null;
}

/** Whether the traveller may pass the portal's quest gate. */
export function isPortalQuestGateOpen(
  portal: PortalQuestGateInput,
  completedQuests: Iterable<string> | null | undefined,
  bypass: boolean = false,
): boolean {
  const required = portalRequiredQuest(portal);
  if (!required || bypass) return true;
  for (const id of completedQuests ?? []) if (id === required) return true;
  return false;
}
